import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';
import { stripDoctorControlPath } from '@shared/lib/doctor-workspace';

export const useDoctorWorkspace = () => {
  const location = useLocation();
  const { user, actorUser, activeDoctorControlRequest, isDoctorControlMode } = useAuth();

  const normalizedPathname = React.useMemo(
    () => stripDoctorControlPath(location.pathname) ?? location.pathname,
    [location.pathname]
  );

  const resolveDoctorPath = React.useCallback((path: string) => path, []);
  const effectiveOrganizationRoles = user?.organization_roles ?? [];
  const isEffectiveOrganizationOwner = effectiveOrganizationRoles.includes('owner');

  return {
    activeDoctorControlRequest,
    isDelegatedDoctorWorkspace: isDoctorControlMode,
    effectiveDoctorId: user?.as_doctor_id ?? null,
    effectiveDoctorName: isDoctorControlMode
      ? (activeDoctorControlRequest?.doctor.fullName ?? null)
      : null,
    effectivePortalRole: user?.role,
    effectiveOrganizationRoles,
    isEffectiveOrganizationOwner,
    normalizedPathname,
    resolveDoctorPath,
    workspaceHomePath: '/dashboard',
    returnPath: actorUser?.role === 'super_admin' ? '/super-admin/users' : '/admin/users',
  } as const;
};
